export default {"src":"/_next/static/media/calendarCancel_24.620a5590.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};